import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from 'theme/colors';

export const StyledTabs = styled(Tabs)`
  border-bottom: 4px solid ${colors.primary900};
  & .MuiTabs-flexContainer {
    gap: 0;
  }
  & .MuiTabs-indicator {
    display: none;
  }
  & .MuiTabs-scroller {
    overflow: hidden !important;
  }
`;

export const StyledTab = styled(Tab)`
  min-height: 48px;
  color: ${colors.primary900} !important;
  text-transform: none;
  &.Mui-selected {
    background: ${colors.primary25};
    border-radius: 4px;
    color: ${colors.primary900} !important;
  }
  & h6 {
    font-size: 14px;
    line-height: 1rem;
    text-transform: none;
    margin-right: 10px;
  }
`;
